import axios from "axios";
import { ICustomer } from "../../types";

export interface IGetCustomersParams {
    filters: {
        firstName?: string,
        lastName?: string,
        birthDate?: string,
        birthNation?: string,
        birthPlace?: string,
        residenceCountry?: string,
        fiscalCode?: string,
        email?: string,
        mobile?: string,
        drivingLicenseNumber?: string,
        vatNumber?: string;
        companyName?: string;
        partnerType?: string;
        //siren?: string;
        //siret?: string;
    } | null,
    start?: number,
    limit?: number
}

export const getCustomers = async (params: IGetCustomersParams): Promise<{
    list: ICustomer[],
    count: number
}> => {
    const response = await axios.post('/booking/instool/customers', params);
    return response.data;
}